import { useState } from 'react';

/**
 * OperatingHoursForm - Form for adding/editing operating hours
 */
export default function OperatingHoursForm({ onSubmit, onCancel, initialData = null }) {
  // Handle both saleDate (new) and dayOfWeek (legacy) for initial data
  const getInitialDate = () => {
    if (initialData?.saleDate) {
      return new Date(initialData.saleDate).toISOString().split('T')[0];
    }
    return '';
  };
  
  const formatTimeForInput = (timeSpan) => {
    if (!timeSpan) return '';
    // If it's already a string in HH:mm format, return it
    if (typeof timeSpan === 'string' && timeSpan.includes(':')) {
      return timeSpan.substring(0, 5); // Extract HH:mm from "HH:mm:ss" or "HH:mm"
    }
    // If it's a TimeSpan object or string like "08:30:00", parse it
    const parts = timeSpan.toString().split(':');
    return `${parts[0]}:${parts[1]}`;
  };

  const [saleDate, setSaleDate] = useState(getInitialDate());
  const [startTime, setStartTime] = useState(
    formatTimeForInput(initialData?.startTime)
  );
  const [endTime, setEndTime] = useState(
    formatTimeForInput(initialData?.endTime)
  );
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    if (!saleDate) {
      setError('Please select a sale date.');
      return;
    }

    const saleDateObj = new Date(saleDate);
    // Ensure we send null for empty strings, but keep actual time values
    const submitData = {
      saleDate: saleDateObj.toISOString(),
      startTime: startTime && startTime.trim() ? startTime.trim() : null,
      endTime: endTime && endTime.trim() ? endTime.trim() : null,
    };
    
    console.log('Submitting operating hours:', submitData);
    onSubmit(submitData);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4 border border-slate-300 dark:border-slate-600 rounded-xl bg-white dark:bg-slate-800">
      {error && (
        <p className="text-red-600 dark:text-red-400 text-sm">{error}</p>
      )}
      
      <label className="flex flex-col gap-2">
        <span className="text-sm font-medium">Sale Date</span>
        <input
          type="date"
          value={saleDate}
          onChange={(e) => setSaleDate(e.target.value)}
          className="rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 px-3 py-2"
          required
        />
      </label>

      <div className="grid grid-cols-2 gap-4">
        <label className="flex flex-col gap-2">
          <span className="text-sm font-medium">Start Time</span>
          <input
            type="time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 px-3 py-2"
          />
        </label>

        <label className="flex flex-col gap-2">
          <span className="text-sm font-medium">End Time</span>
          <input
            type="time"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 px-3 py-2"
          />
        </label>
      </div>

      <div className="flex gap-2">
        <button
          type="submit"
          className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
        >
          {initialData ? 'Update' : 'Add'} Day
        </button>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-800 dark:text-slate-200 font-semibold py-2 px-4 rounded-lg transition-colors"
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}
